import * as App from '../index'
import { msalConfig } from "../authConfig"
import { InteractionRequiredAuthError } from "@azure/msal-browser"
import { format } from 'date-fns'

BigInt.prototype.toJSON = function () {
    return this.toString();
}
Date.prototype.toJSON = function () {
    return format(this,"yyyy-MM-dd'T'HH:mm:ssxxx")
}

export const callApiWithToken = async (endpoint, accessToken, body) => {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    }

    const options = {
        method: 'POST',// body ? 'POST' : 'GET',
        headers: headers
    };

    if (body) {
        options.body = JSON.stringify(body)
    }

    //console.log('options', options)
    let data
    try {
        const response = await window.fetch(endpoint, options)
        if (response.ok) {
            data = await response.json()
            return data
        }
        if (response.status === 503) {
            throw new Error('Service is temporarily unavailable. Please try again.')
        }
        if (response.statusText.length === 0) {
            const type = response.headers.get('content-type')
            if (type?.includes('application/json')) {
                data = await response.json()
                if (data.title) {
                    throw new Error(`${data.title} ${JSON.stringify(data.errors)}`)
                } else {
                    throw new Error(`${JSON.stringify(data)}`)
                }
            } else {
                data = await response.text()
                if (data !== '') {
                    throw new Error(data)
                } else {
                    throw new Error(`Server returned a status of ${response.status}`)
                }
            }
        } else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        return Promise.reject(err.message ? err.message : data)
    }
}
export const callApi = async (endpoint, body) => {
    const account = App.msalInstance.getAllAccounts()[0]
    const tokenRequest = {
        account: account,
        scopes: msalConfig.auth.scopes,
    }
    let authenticationResult
    try {
        authenticationResult = await App.msalInstance.acquireTokenSilent(tokenRequest)
    } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
            App.msalInstance.acquireTokenRedirect(tokenRequest)
            return Promise.reject(`${err.errorCode}: ${err.errorMessage}`)
        }
    }

    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authenticationResult.accessToken}`
    }

    const options = {
        method: 'POST',
        headers: headers
    };

    //console.log('body', body)
    if (body) {
        options.body = JSON.stringify(body)
    }

    //console.log('endpoint', endpoint,'options', options)
    let data
    try {
        const response = await window.fetch(endpoint, options)
        if (response.ok) {
            data = await response.json()
            return data
        }
        if (response.status === 503) {
            throw new Error('Service is temporarily unavailable. Please try again.')
        }
        if (response.statusText.length === 0) {
            const type = response.headers.get('content-type')
            if (type?.includes('application/json')) {
                data = await response.json()
                if (data.title) {
                    throw new Error(`${data.title} ${JSON.stringify(data.errors)}`)
                } else if (data.error) {
                    throw new Error(`${data.error} ${data.error_description}`)
                } else {
                    throw new Error(`${JSON.stringify(data)}`)
                }
            } else {
                data = await response.text()
                if (data !== '') {
                    throw new Error(data)
                } else {
                    throw new Error(`Server returned a status of ${response.status}`)
                }
            }
        } else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        return Promise.reject(err.message ? err.message : data)
    }
}
export async function client(endpoint, { token, body } = {}) {

    const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }

    const config = {
        method: body ? 'POST' : 'GET',
        headers: {
            ...headers,
        },
    }

    if (body) {
        config.body = JSON.stringify(body)
    }

    let data
    try {
        const response = await window.fetch(endpoint, config)
        data = await response.json()
        if (response.ok) {
            return data
        }
        throw new Error(response.statusText)
    } catch (err) {
        return Promise.reject(err.message ? err.message : data)
    }
}
client.get = function (endpoint, token) {
    return client(endpoint, { token })
}

client.post = function (endpoint, body, token) {
    return client(endpoint, { token, body })
}
